function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1932(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 23.71,
    height: 15.12,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1630769230769231
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 7.56
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 15.12,
    width: 23.71,
    height: 17.54,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 23.89
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 32.66,
    width: 23.71,
    height: 19.4,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.7714285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 42.36
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 52.06,
    width: 23.71,
    height: 19.64,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8057142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 61.88
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 71.71,
    width: 23.71,
    height: 20.86,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.953333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 82.13999999999999
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 92.56,
    width: 23.71,
    height: 22.72,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.84
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 103.92
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 115.28,
    width: 23.71,
    height: 23.44,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 127
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 138.72,
    width: 23.71,
    height: 24.9,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3871428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 151.17
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 163.62,
    width: 23.71,
    height: 29.35,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.96375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 178.29500000000002
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 192.97,
    width: 23.71,
    height: 30.15,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.742
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 208.045
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 223.12,
    width: 23.71,
    height: 32.01,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9516666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 239.125
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 255.13,
    width: 23.71,
    height: 32.34,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.96375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 271.3
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 287.47,
    width: 23.71,
    height: 32.98,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9516666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 303.96000000000004
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 320.45,
    width: 23.71,
    height: 33.87,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9516666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 337.385
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 354.32,
    width: 23.71,
    height: 36.22,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.9275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 372.43
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 390.54,
    width: 23.71,
    height: 36.3,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.9275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 408.69
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 426.84,
    width: 23.71,
    height: 37.91,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9516666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 445.79499999999996
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 464.75,
    width: 23.71,
    height: 38.32,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9516666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 483.91
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 503.07,
    width: 23.71,
    height: 38.72,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9516666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 522.43
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 541.79,
    width: 23.71,
    height: 39.05,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.96375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 561.3149999999999
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 580.84,
    width: 23.71,
    height: 39.37,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3871428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 600.525
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 620.21,
    width: 23.71,
    height: 39.61,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3871428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 640.015
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 659.82,
    width: 23.71,
    height: 40.18,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3871428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.855,
    y: 679.9100000000001
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.71,
    y: 0,
    width: 28.51,
    height: 34.03,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.851
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.965,
    y: 17.015
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.22,
    y: 0,
    width: 29.41,
    height: 34.03,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.882
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.925,
    y: 17.015
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.63,
    y: 0,
    width: 29.75,
    height: 34.03,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.95
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 96.505,
    y: 17.015
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.38,
    y: 0,
    width: 29.86,
    height: 34.03,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.265714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.31,
    y: 17.015
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.24,
    y: 0,
    width: 30.37,
    height: 34.03,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.79625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 156.425,
    y: 17.015
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.6,
    y: 0,
    width: 31.04,
    height: 34.03,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.434285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.12,
    y: 17.015
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202.65,
    y: 0,
    width: 31.32,
    height: 34.03,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.264
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.31,
    y: 17.015
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.97,
    y: 0,
    width: 31.38,
    height: 34.03,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.482857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 249.66,
    y: 17.015
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.35,
    y: 0,
    width: 32.45,
    height: 34.03,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.49
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.57500000000005,
    y: 17.015
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 297.8,
    y: 0,
    width: 34.03,
    height: 34.03,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.25375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 314.815,
    y: 17.015
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 331.83,
    y: 0,
    width: 34.14,
    height: 34.03,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.861428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 348.9,
    y: 17.015
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 365.97,
    y: 0,
    width: 34.37,
    height: 34.03,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.781111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 383.15500000000003,
    y: 17.015
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 400.34,
    y: 0,
    width: 36.34,
    height: 34.03,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.671666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 418.51,
    y: 17.015
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436.67,
    y: 0,
    width: 36.73,
    height: 34.03,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.806
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 455.035,
    y: 17.015
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 473.41,
    y: 0,
    width: 36.96,
    height: 34.03,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.806
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 491.89000000000004,
    y: 17.015
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510.37,
    y: 0,
    width: 37.41,
    height: 34.03,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.861428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 529.075,
    y: 17.015
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547.77,
    y: 0,
    width: 37.41,
    height: 34.03,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.671666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 566.475,
    y: 17.015
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 585.18,
    y: 0,
    width: 37.46,
    height: 34.03,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.861428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.91,
    y: 17.015
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 622.65,
    y: 0,
    width: 38.08,
    height: 34.03,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.671666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 641.6899999999999,
    y: 17.015
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 660.73,
    y: 0,
    width: 39.27,
    height: 34.03,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.671666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 680.365,
    y: 17.015
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.71,
    y: 34.03,
    width: 38.94,
    height: 35.3,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.18,
    y: 51.68
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.71,
    y: 69.33,
    width: 38.94,
    height: 35.35,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.891666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.18,
    y: 87.005
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.71,
    y: 104.68,
    width: 38.94,
    height: 35.75,
    style: {
      fill: "#999999"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9722222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.18,
    y: 122.555
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.71,
    y: 140.43,
    width: 38.94,
    height: 36.04,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.006666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.18,
    y: 158.45000000000002
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.71,
    y: 176.47,
    width: 38.94,
    height: 36.43,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.18,
    y: 194.685
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.71,
    y: 212.9,
    width: 38.94,
    height: 37.07,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.295714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.18,
    y: 231.435
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.71,
    y: 249.98,
    width: 38.94,
    height: 37.12,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.4239999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.18,
    y: 268.53999999999996
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.71,
    y: 287.1,
    width: 38.94,
    height: 38.9,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.483333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.18,
    y: 306.55
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.71,
    y: 326,
    width: 38.94,
    height: 39.04,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.8675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.18,
    y: 345.52
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.71,
    y: 365.05,
    width: 38.94,
    height: 39.24,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.562857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.18,
    y: 384.67
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.71,
    y: 404.29,
    width: 38.94,
    height: 39.68,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.489999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.18,
    y: 424.13
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.71,
    y: 443.97,
    width: 38.94,
    height: 39.68,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.8675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.18,
    y: 463.81
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.71,
    y: 483.66,
    width: 38.94,
    height: 42.05,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.562857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.18,
    y: 504.685
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.71,
    y: 525.7,
    width: 38.94,
    height: 43.08,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.489999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.18,
    y: 547.24
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.71,
    y: 568.79,
    width: 38.94,
    height: 43.57,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.8675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.18,
    y: 590.5749999999999
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.71,
    y: 612.36,
    width: 38.94,
    height: 43.67,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.735
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.18,
    y: 634.195
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.71,
    y: 656.03,
    width: 38.94,
    height: 43.97,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8939999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.18,
    y: 678.015
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.65,
    y: 34.03,
    width: 39.86,
    height: 46.17,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.6433333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.58,
    y: 57.115
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.51,
    y: 34.03,
    width: 40.36,
    height: 46.17,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.726666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.69,
    y: 57.115
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.87,
    y: 34.03,
    width: 40.57,
    height: 46.17,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.761666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.155,
    y: 57.115
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.44,
    y: 34.03,
    width: 40.65,
    height: 46.17,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.129999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 203.765,
    y: 57.115
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.09,
    y: 34.03,
    width: 40.98,
    height: 46.17,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.854285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 244.58,
    y: 57.115
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.07,
    y: 34.03,
    width: 41.15,
    height: 46.17,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 285.645,
    y: 57.115
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.21,
    y: 34.03,
    width: 41.73,
    height: 46.17,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.961428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 327.075,
    y: 57.115
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 347.94,
    y: 34.03,
    width: 41.77,
    height: 46.17,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.961666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 368.825,
    y: 57.115
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 389.71,
    y: 34.03,
    width: 42.19,
    height: 46.17,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.437999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 410.80499999999995,
    y: 57.115
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 431.9,
    y: 34.03,
    width: 42.64,
    height: 46.17,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.091428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 453.21999999999997,
    y: 57.115
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 474.54,
    y: 34.03,
    width: 43.68,
    height: 46.17,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.46
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 496.38,
    y: 57.115
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 518.22,
    y: 34.03,
    width: 44.18,
    height: 46.17,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.045
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 540.3100000000001,
    y: 57.115
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 562.4,
    y: 34.03,
    width: 45.13,
    height: 46.17,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.4471428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 584.965,
    y: 57.115
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 607.53,
    y: 34.03,
    width: 46.13,
    height: 46.17,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.226
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 630.595,
    y: 57.115
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 653.66,
    y: 34.03,
    width: 46.34,
    height: 46.17,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.77125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 676.8299999999999,
    y: 57.115
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.65,
    y: 80.2,
    width: 48.57,
    height: 44.09,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.298571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.935,
    y: 102.245
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.65,
    y: 124.29,
    width: 48.57,
    height: 44.56,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.426666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.935,
    y: 146.57
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.65,
    y: 168.86,
    width: 48.57,
    height: 45.2,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.533333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.935,
    y: 191.46
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.65,
    y: 214.05,
    width: 48.57,
    height: 45.43,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.086
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.935,
    y: 236.76500000000001
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.65,
    y: 259.49,
    width: 48.57,
    height: 45.47,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.094
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.935,
    y: 282.225
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.65,
    y: 304.96,
    width: 48.57,
    height: 45.67,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.524285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.935,
    y: 327.79499999999996
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.65,
    y: 350.63,
    width: 48.57,
    height: 48.31,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.051666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.935,
    y: 374.78499999999997
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.65,
    y: 398.94,
    width: 48.57,
    height: 48.63,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.935,
    y: 423.255
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.65,
    y: 447.57,
    width: 48.57,
    height: 49.18,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.095
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.935,
    y: 472.15999999999997
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.65,
    y: 496.76,
    width: 48.57,
    height: 49.62,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.938571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.935,
    y: 521.5699999999999
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.65,
    y: 546.37,
    width: 48.57,
    height: 50.29,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.1425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.935,
    y: 571.515
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.65,
    y: 596.66,
    width: 48.57,
    height: 50.45,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.935,
    y: 621.885
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.65,
    y: 647.11,
    width: 48.57,
    height: 52.89,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.938571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.935,
    y: 673.5550000000001
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.22,
    y: 80.2,
    width: 50.87,
    height: 51.29,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.174
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.655,
    y: 105.845
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.1,
    y: 80.2,
    width: 51.44,
    height: 51.29,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.41125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.82,
    y: 105.845
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.53,
    y: 80.2,
    width: 51.7,
    height: 51.29,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.41125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.38,
    y: 105.845
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.23,
    y: 80.2,
    width: 52.44,
    height: 51.29,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.327142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 291.45000000000005,
    y: 105.845
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.67,
    y: 80.2,
    width: 53.79,
    height: 51.29,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.258
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 344.565,
    y: 105.845
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 371.46,
    y: 80.2,
    width: 53.83,
    height: 51.29,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.8225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 398.375,
    y: 105.845
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.29,
    y: 80.2,
    width: 54.28,
    height: 51.29,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.258
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 452.43,
    y: 105.845
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.57,
    y: 80.2,
    width: 54.61,
    height: 51.29,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.41125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 506.875,
    y: 105.845
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 534.18,
    y: 80.2,
    width: 54.8,
    height: 51.29,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.8225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 561.5799999999999,
    y: 105.845
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 588.98,
    y: 80.2,
    width: 55.51,
    height: 51.29,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.327142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 616.735,
    y: 105.845
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 644.49,
    y: 80.2,
    width: 55.51,
    height: 51.29,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.327142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 672.245,
    y: 105.845
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.22,
    y: 131.49,
    width: 53.48,
    height: 53.66,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.696
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.96,
    y: 158.32
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.22,
    y: 185.15,
    width: 53.48,
    height: 53.81,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.685
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.96,
    y: 212.055
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.22,
    y: 238.96,
    width: 53.48,
    height: 53.99,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.913333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.96,
    y: 265.955
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.22,
    y: 292.95,
    width: 53.48,
    height: 54.92,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.696
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.96,
    y: 320.40999999999997
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.22,
    y: 347.87,
    width: 53.48,
    height: 54.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.696
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.96,
    y: 375.33
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.22,
    y: 402.79,
    width: 53.48,
    height: 55.06,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.942222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.96,
    y: 430.32000000000005
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.22,
    y: 457.85,
    width: 53.48,
    height: 60.12,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.913333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.96,
    y: 487.91
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.22,
    y: 517.96,
    width: 53.48,
    height: 60.37,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.696
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.96,
    y: 548.145
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.22,
    y: 578.33,
    width: 53.48,
    height: 60.65,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.913333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.96,
    y: 608.6550000000001
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.22,
    y: 638.99,
    width: 53.48,
    height: 61.01,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.913333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.96,
    y: 669.495
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.7,
    y: 131.49,
    width: 55.5,
    height: 59.59,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.1
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.45,
    y: 161.28500000000003
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.2,
    y: 131.49,
    width: 55.56,
    height: 59.59,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 247.98,
    y: 161.28500000000003
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.76,
    y: 131.49,
    width: 56.3,
    height: 59.59,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.042857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 303.90999999999997,
    y: 161.28500000000003
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.06,
    y: 131.49,
    width: 58.74,
    height: 59.59,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.790000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 361.43,
    y: 161.28500000000003
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.8,
    y: 131.49,
    width: 59.45,
    height: 59.59,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.908333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 420.52500000000003,
    y: 161.28500000000003
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 450.25,
    y: 131.49,
    width: 62.28,
    height: 59.59,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.931666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 481.39,
    y: 161.28500000000003
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 512.54,
    y: 131.49,
    width: 62.28,
    height: 59.59,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.9590000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 543.68,
    y: 161.28500000000003
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 574.82,
    y: 131.49,
    width: 62.54,
    height: 59.59,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.512857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 606.09,
    y: 161.28500000000003
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 637.36,
    y: 131.49,
    width: 62.64,
    height: 59.59,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.621111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.6800000000001,
    y: 161.28500000000003
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.7,
    y: 191.08,
    width: 64.31,
    height: 61.38,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.6725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.855,
    y: 221.77
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.7,
    y: 252.46,
    width: 64.31,
    height: 63.11,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.012222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.855,
    y: 284.015
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.7,
    y: 315.57,
    width: 64.31,
    height: 63.11,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.88875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.855,
    y: 347.125
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.7,
    y: 378.68,
    width: 64.31,
    height: 63.17,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.528333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.855,
    y: 410.265
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.7,
    y: 441.84,
    width: 64.31,
    height: 64.21,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.841999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.855,
    y: 473.945
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.7,
    y: 506.05,
    width: 64.31,
    height: 64.51,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.718333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.855,
    y: 538.3050000000001
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.7,
    y: 570.56,
    width: 64.31,
    height: 64.69,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.187142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.855,
    y: 602.905
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.7,
    y: 635.25,
    width: 64.31,
    height: 64.75,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.718333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.855,
    y: 667.625
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.01,
    y: 191.08,
    width: 65.94,
    height: 63.27,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.90875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.98,
    y: 222.715
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.95,
    y: 191.08,
    width: 67.12,
    height: 63.27,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.038571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 328.51,
    y: 222.715
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.07,
    y: 191.08,
    width: 67.45,
    height: 63.27,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.90875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 395.795,
    y: 222.715
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 429.52,
    y: 191.08,
    width: 67.48,
    height: 63.27,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.038571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 463.26,
    y: 222.715
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 497.01,
    y: 191.08,
    width: 67.6,
    height: 63.27,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.038571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 530.81,
    y: 222.715
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 564.61,
    y: 191.08,
    width: 67.66,
    height: 63.27,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 598.44,
    y: 222.715
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 632.27,
    y: 191.08,
    width: 67.73,
    height: 63.27,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 666.135,
    y: 222.715
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.01,
    y: 254.35,
    width: 71.06,
    height: 60.73,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.59125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.53999999999996,
    y: 284.715
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.01,
    y: 315.08,
    width: 71.06,
    height: 60.81,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.162
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.53999999999996,
    y: 345.485
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.01,
    y: 375.89,
    width: 71.06,
    height: 62.32,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.464
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.53999999999996,
    y: 407.05
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.01,
    y: 438.21,
    width: 71.06,
    height: 64.24,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.06
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.53999999999996,
    y: 470.33
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.01,
    y: 502.45,
    width: 71.06,
    height: 65.05,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.227777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.53999999999996,
    y: 534.975
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.01,
    y: 567.5,
    width: 71.06,
    height: 66.21,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.241999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.53999999999996,
    y: 600.605
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.01,
    y: 633.71,
    width: 71.06,
    height: 66.29,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.53999999999996,
    y: 666.855
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.07,
    y: 254.35,
    width: 65.42,
    height: 78.01,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.542
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 332.78,
    y: 293.355
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 365.49,
    y: 254.35,
    width: 66.13,
    height: 78.01,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.021666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 398.555,
    y: 293.355
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 431.62,
    y: 254.35,
    width: 66.55,
    height: 78.01,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.31875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 464.895,
    y: 293.355
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 498.17,
    y: 254.35,
    width: 66.6,
    height: 78.01,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.1
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 531.47,
    y: 293.355
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 564.76,
    y: 254.35,
    width: 66.92,
    height: 78.01,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.73
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 598.22,
    y: 293.355
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 631.68,
    y: 254.35,
    width: 68.32,
    height: 78.01,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.08
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 665.8399999999999,
    y: 293.355
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.07,
    y: 332.36,
    width: 83.25,
    height: 65.47,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.094
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.695,
    y: 365.095
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.07,
    y: 397.83,
    width: 83.25,
    height: 67.06,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.4511111111111115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.695,
    y: 431.36
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.07,
    y: 464.89,
    width: 83.25,
    height: 76.48,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.12
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.695,
    y: 503.13
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.07,
    y: 541.37,
    width: 83.25,
    height: 76.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.826666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.695,
    y: 579.85
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.07,
    y: 618.34,
    width: 83.25,
    height: 81.66,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.665714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.695,
    y: 659.1700000000001
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.32,
    y: 332.36,
    width: 68.84,
    height: 101.7,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.605
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 417.74,
    y: 383.21000000000004
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 452.16,
    y: 332.36,
    width: 69.13,
    height: 101.7,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.64125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 486.725,
    y: 383.21000000000004
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 521.29,
    y: 332.36,
    width: 88.07,
    height: 101.7,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.613999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 565.3249999999999,
    y: 383.21000000000004
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 609.36,
    y: 332.36,
    width: 90.64,
    height: 101.7,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 654.6800000000001,
    y: 383.21000000000004
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.32,
    y: 434.06,
    width: 84.58,
    height: 129.06,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.5725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 425.61,
    y: 498.59000000000003
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.32,
    y: 563.12,
    width: 84.58,
    height: 136.88,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.082857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 425.61,
    y: 631.56
  }, "\n        De_Kalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 467.9,
    y: 434.06,
    width: 232.1,
    height: 80.48,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.497142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 583.9499999999999,
    y: 474.3
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 467.9,
    y: 514.54,
    width: 232.1,
    height: 185.46,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 30.91
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 583.9499999999999,
    y: 607.27
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1932);
export default __webpack_public_path__ + "static/media/1932.e5a4a1b333fe61b3b6c4833868407215.svg";
export { ForwardRef as ReactComponent };